
import { defineComponent, ref } from 'vue';
import ChartSettingsModal from '@/components/ChartSettingsModal.vue';
import ConcentrationChart from '@/components/ConcentrationChart.vue';
import { useChartsStore } from '@/store/charts';
import Report from './Report.vue';

export default defineComponent({
    components: {
        ChartSettingsModal,
        ConcentrationChart,
        Report,
    },

    setup()
    {
        const chartStore = useChartsStore();
        const dataArea = ref<HTMLElement|null>();
        const chartScreenshot = ref<string|null>();

        const isSettingsModalOpen = ref(false);

        function takeChartScreenshot()
        {
            const canvasElement = dataArea.value?.querySelector("[data-chart-canvas]");

            if (!(canvasElement instanceof HTMLCanvasElement)) {
                return;
            }

            chartScreenshot.value = canvasElement.toDataURL("image/png");
        }

        return {
            chartStore,
            dataArea,
            isSettingsModalOpen,
            chartScreenshot,
            takeChartScreenshot,
        };
    },
});
